import React, { useEffect, useState } from "react";
import { EqualizerContainer, EqualizerBar } from "./audio-player.styles";

const BAR_COUNT = 24;
const MIN_BAR_HEIGHT = 6;
const MAX_BAR_HEIGHT = 40;
const INITIAL_BAR_HEIGHT =
  MIN_BAR_HEIGHT + (MAX_BAR_HEIGHT - MIN_BAR_HEIGHT) * 0.2;

interface StreamingEqualizerProps {
  isPlaying: boolean;
  chunksReceived: number;
}

interface BarAnimation {
  firstHeight: number;
  secondHeight: number;
  duration: number;
}

const createBarAnimations = (): BarAnimation[] =>
  Array.from({ length: BAR_COUNT }, () => ({
    firstHeight: INITIAL_BAR_HEIGHT,
    secondHeight:
      MIN_BAR_HEIGHT + Math.random() * (MAX_BAR_HEIGHT - MIN_BAR_HEIGHT),
    duration: 200 + Math.random() * 300
  }));

export const StreamingEqualizer: React.FC<StreamingEqualizerProps> = ({
  isPlaying,
  chunksReceived
}) => {
  const isActive = isPlaying && chunksReceived > 0;
  const [barAnimations, setBarAnimations] = useState(createBarAnimations);
  const [animationVersion, setAnimationVersion] = useState(0);

  useEffect(() => {
    if (!isActive) return;

    setBarAnimations(createBarAnimations());
    setAnimationVersion((version) => version + 1);
  }, [isActive, chunksReceived]);

  return (
    <EqualizerContainer>
      {barAnimations.map((animation, index) => (
        <EqualizerBar
          key={`${index}-${animationVersion}`}
          $active={isActive}
          $firstHeight={animation.firstHeight}
          $secondHeight={animation.secondHeight}
          $duration={animation.duration}
        />
      ))}
    </EqualizerContainer>
  );
};
